import './AppStatusIndicator.scss';

import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityAppActiveStatusType } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarText } from '@ui/text';

const statusLabel: Record<DataSecurityAppActiveStatusType, string> = {
	[ DataSecurityAppActiveStatusType.Operational ]: COPY_SPECIFIC.OPERATIONAL,
	[ DataSecurityAppActiveStatusType.Unknown ]: COPY_SPECIFIC.UNKNOWN,
	[ DataSecurityAppActiveStatusType.Major ]: COPY_SPECIFIC.API_DOWNTIME,
	[ DataSecurityAppActiveStatusType.Minor ]: COPY_SPECIFIC.API_DOWNTIME,
	[ DataSecurityAppActiveStatusType.Critical ]: COPY_SPECIFIC.OUTAGE
};

export interface AppStatusTagProps {
	statusType: DataSecurityAppActiveStatusType;
}

export const AppStatusIndicator: React.FC<AppStatusTagProps> = ({ statusType }) => {
	const title = String(statusType);
	const innerClasses = classNames('status-indicator-inner', title?.toLowerCase());

	return (
		<div className='app-status-indicator'>
			<div className='status-indicator'>
				<div className={ innerClasses } />
			</div>
			<SonarText weight='semibold'>{ statusLabel[ statusType ] }</SonarText>
		</div>
	);
};
